import QRCode from 'qrcode';

/** Code 128B patterns, values 0–106 (stop is 106). */
const C128 = [
  '11011001100', '11001101100', '11001100110', '10010011000', '10010001100',
  '10001001100', '10011001000', '10011000100', '10001100100', '11001001000',
  '11001000100', '11000100100', '10110011100', '10011011100', '10011001110',
  '10111001100', '10011101100', '10011100110', '11001110010', '11001011100',
  '11001001110', '11011100100', '11001110100', '11101101110', '11101001100',
  '11100101100', '11100100110', '11101100100', '11100110100', '11100110010',
  '11011011000', '11011000110', '11000110110', '10100011000', '10001011000',
  '10001000110', '10110001000', '10001101000', '10001100010', '11010001000',
  '11000101000', '11000100010', '10110111000', '10110001110', '10001101110',
  '10111011000', '10111000110', '10001110110', '11101110110', '11010001110',
  '11000101110', '11011101000', '11011100010', '11011101110', '11101011000',
  '11101000110', '11100010110', '11101101000', '11101100010', '11100011010',
  '11101111010', '11001000010', '11110001010', '10100110000', '10100001100',
  '10010110000', '10010000110', '10000101100', '10000100110', '10110010000',
  '10110000100', '10011010000', '10011000010', '10000110100', '10000110010',
  '11000010010', '11001010000', '11110111010', '11000010100', '10001111010',
  '10100111100', '10010111100', '10010011110', '10111100100', '10011110100',
  '10011110010', '11110100100', '11110010100', '11110010010', '11011011110',
  '11011110110', '11110110110', '10101111000', '10100011110', '10001011110',
  '10111101000', '10111100010', '11110101000', '11110100010', '10111011110',
  '10111101110', '11101011110', '11110101110', '11010000100', '11010010000',
  '11010011100', '11000111010',
];

export const drawCode128 = (
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  w: number,
  h: number,
  color = '#0f172a',
) => {
  const payload = String(text || '').replace(/[^\x20-\x7F]/g, '?') || '0';
  const values = [104];
  for (let i = 0; i < payload.length; i += 1) values.push(payload.charCodeAt(i) - 32);
  let checksum = values[0];
  for (let i = 1; i < values.length; i += 1) checksum += values[i] * i;
  values.push(checksum % 103, 106);
  const bits = `${values.map((value) => C128[value]).join('')}11`;
  const module = w / bits.length;
  ctx.fillStyle = color;
  for (let i = 0; i < bits.length; i += 1) {
    if (bits[i] === '1') ctx.fillRect(x + i * module, y, module + 0.35, h);
  }
};

export const drawQr = (
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  size: number,
  dark = '#0f172a',
  light = '#ffffff',
  logo?: HTMLImageElement | null,
) => {
  const qr = QRCode.create(String(text || '0'), { errorCorrectionLevel: 'H' });
  const modules = qr.modules;
  const n = modules.size;
  const quiet = 4;
  const dim = n + quiet * 2;
  const cell = Math.max(1, Math.floor(size / dim));
  const used = cell * dim;
  const ox = x + Math.floor((size - used) / 2);
  const oy = y + Math.floor((size - used) / 2);

  ctx.fillStyle = light;
  ctx.fillRect(x, y, size, size);
  ctx.fillStyle = dark;
  for (let row = 0; row < n; row += 1) {
    for (let col = 0; col < n; col += 1) {
      if (modules.get(row, col)) {
        ctx.fillRect(ox + (col + quiet) * cell, oy + (row + quiet) * cell, cell, cell);
      }
    }
  }

  if (!logo) return;
  // EC H recovers ~30%. Keep the logo+pad under ~20% of the symbol so scanners
  // still read the payload after the center is covered.
  const logoBox = used * 0.18;
  const pad = Math.max(3, used * 0.015);
  const lx = ox + (used - logoBox) / 2;
  const ly = oy + (used - logoBox) / 2;
  const r = Math.max(4, logoBox * 0.12);
  const bx = lx - pad;
  const by = ly - pad;
  const bw = logoBox + pad * 2;
  const bh = logoBox + pad * 2;
  ctx.fillStyle = light;
  ctx.beginPath();
  ctx.moveTo(bx + r, by);
  ctx.arcTo(bx + bw, by, bx + bw, by + bh, r);
  ctx.arcTo(bx + bw, by + bh, bx, by + bh, r);
  ctx.arcTo(bx, by + bh, bx, by, r);
  ctx.arcTo(bx, by, bx + bw, by, r);
  ctx.closePath();
  ctx.fill();
  const ratio = Math.min(logoBox / logo.width, logoBox / logo.height);
  const w = logo.width * ratio;
  const h = logo.height * ratio;
  ctx.drawImage(logo, lx + (logoBox - w) / 2, ly + (logoBox - h) / 2, w, h);
};
